import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getDb } from "../../../util/Constants";
import { collection, addDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import { Row, Col } from "reactstrap";

export default function AddMiniGame7Modal({ isOpen, toggle, onQuestionAdded }) {
  const [Description, setDescription] = useState("");
  const [WeightBlue, setWeightBlue] = useState("");
  const [WeightGreen, setWeightGreen] = useState("");
  const [WeightRed, setWeightRed] = useState("");
  const [WeightYellow, setWeightYellow] = useState("");
  const [s1Limit, setS1Limit] = useState("");
  const [s2Limit, setS2Limit] = useState("");
  const [loading, setLoading] = useState(false);

  const resetFields = () => {
    setDescription("");
    setWeightBlue("");
    setWeightGreen("");
    setWeightRed("");
    setWeightYellow("");
    setS1Limit("");
    setS2Limit("");
  };

  const handleSubmit = async () => {
    if (
      !Description.trim() ||
      !WeightBlue ||
      !WeightGreen ||
      !WeightRed ||
      !WeightYellow ||
      !s1Limit ||
      !s2Limit
    ) {
      Swal.fire("Error", "Please fill all fields.", "error");
      return;
    }
    setLoading(true);
    try {
      await addDoc(collection(getDb(), "questions"), {
        miniGame: "Mini 7",
        Description: Description.trim(),
        WeightBlue: Number(WeightBlue),
        WeightGreen: Number(WeightGreen),
        WeightRed: Number(WeightRed),
        WeightYellow: Number(WeightYellow),
        s1Limit: Number(s1Limit),
        s2Limit: Number(s2Limit),
        levelRef: 1,
      });
      Swal.fire("Success", "Question added!", "success");
      resetFields();
      toggle();
      if (onQuestionAdded) onQuestionAdded();
    } catch (error) {
      Swal.fire("Error", "Failed to add question.", "error");
    }
    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="m">
      <ModalHeader toggle={toggle}>Add MiniGame 7 Question</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>Description</Label>
          <Input
            type="textarea"
            value={Description}
            onChange={(e) => setDescription(e.target.value)}
            rows={3}
            placeholder="Enter description"
          />
        </FormGroup>
        <Row>
          <Col xs={6}>
            <FormGroup>
              <Label>Weight Blue</Label>
              <Input
                type="number"
                value={WeightBlue}
                onChange={(e) => setWeightBlue(e.target.value)}
                placeholder="Enter Weight Blue"
                min={0}
              />
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup>
              <Label>Weight Green</Label>
              <Input
                type="number"
                value={WeightGreen}
                onChange={(e) => setWeightGreen(e.target.value)}
                placeholder="Enter Weight Green"
                min={0}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <FormGroup>
              <Label>Weight Red</Label>
              <Input
                type="number"
                value={WeightRed}
                onChange={(e) => setWeightRed(e.target.value)}
                placeholder="Enter Weight Red"
                min={0}
              />
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup>
              <Label>Weight Yellow</Label>
              <Input
                type="number"
                value={WeightYellow}
                onChange={(e) => setWeightYellow(e.target.value)}
                placeholder="Enter Weight Yellow"
                min={0}
              />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <Label>S1 Limit</Label>
          <Input
            type="number"
            value={s1Limit}
            onChange={(e) => setS1Limit(e.target.value)}
            placeholder="Enter S1 Limit"
            min={0}
          />
        </FormGroup>
        <FormGroup>
          <Label>S2 Limit</Label>
          <Input
            type="number"
            value={s2Limit}
            onChange={(e) => setS2Limit(e.target.value)}
            placeholder="Enter S2 Limit"
            min={0}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Adding..." : "Add"}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
